import { FacilitatorRoutes, GamerRoutes } from '../../../config/routes/routeEnums'

/**
 * When switching orgs, navigate away from routes that show tenant-specific data
 * keyed without orgId (or tied to the previous org context).
 */
export function getSafeRouteAfterOrgSwitch(pathname: string): string | null {
  const normalized = pathname.replace(/\/$/, '') || '/'

  if (normalized.includes('/facilitator/organization/')) {
    return FacilitatorRoutes.DASHBOARD
  }
  if (normalized.includes('/facilitate-reflection')) {
    return FacilitatorRoutes.MANAGE_REFLECTIONS
  }
  if (/\/facilitator\/sprint\/[^/]+/.test(normalized)) {
    return FacilitatorRoutes.TRAINING_SPRINT_MANAGEMENT
  }
  if (normalized.includes('/facilitator/generate-report')) {
    return FacilitatorRoutes.MANAGE_REPORTS
  }

  if (normalized.startsWith(GamerRoutes.BASE) && normalized !== GamerRoutes.DASHBOARD) {
    // Gamer routes are mostly user-scoped; dashboard is the safest landing after switch.
    if (
      normalized.includes('/activity-details') ||
      normalized.includes('/ai-coach') ||
      normalized.includes('/latest-session-feedback')
    ) {
      return GamerRoutes.DASHBOARD
    }
  }

  return null
}
